import React, { useState } from "react";
import ssoImg1 from "./../../../../assets/images/fishing-img.png"; // Adjust the path as necessary
import ssoImg2 from "./../../../../assets/images/mrcc-2.png"; // Adjust the path as necessary
import horizon1 from './../../../../assets/images/horizontal-img-1.png';
import pilotIcon from "./../../../../assets/images/user-pilot-tie.svg"; // Adjust the path as necessary
import scaleIcon from "./../../../../assets/images/scale-balanced.svg"; // Adjust the path as necessary

import { FaFacebookF, FaLinkedinIn, FaTwitter, FaYoutube, FaUser, FaInstagram } from 'react-icons/fa';

function FishingOverviewTab() {
      const cardData = [
    {
      icon: pilotIcon,
      shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
      twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
      linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
      ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
      cardTitle: 'Safety Inspections',
      cardDescription: "Executes a Maritime Assistance Service (MAS)",
    },
    {
      icon: scaleIcon,
      shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
      twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
      linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
      ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
      cardTitle: 'Governance Policies',
      cardDescription: "STCW-F; Torremolinos and Work In Fishing Convention (C188)",
    },
    {
      icon: scaleIcon,
      shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
      twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
      linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
      instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
      ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
      cardTitle: 'Industry development',
      cardDescription: "Understanding and addressing issues that increase costs to the industry & ensure economic growth.",
    },
    
 
  
    
    
    
  
    
  ];
  
 
  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        FISHING
        <span className="text-orange-ef3e33 font-400"> overview </span>
      </div>

      <div className="row g-3 g-sm-4 g-md-5">
        <div className="col-lg">
          <p className="mb-3 text-primary-color">
            The Centre maintain its role in ensuring safety of life and property
            at sea, maintain clean seas, whilst looking at adequate welfare of
            fishermen and industry development initiatives.
          </p>

          <p className="mb-3 text-primary-color">
            The Centre is also secretariat to National Fishing Forum, to ensure
            the competitiveness of the Industry through stakeholder engagements;
          </p>

          <div className="row g-4">
            <div className="col-xl-6 col-md-6 col-sm-6">
              <div className="gray-card-wrap">
                <div className="gray-card bg-gray-de bg-opacity-10 d-flex flex-column align-items-center">
                  <div className="icon">
                    <img src={pilotIcon} alt="" />
                  </div>
                  <div className="text-center text-primary-color font-600">
                    Involved in
                  </div>
                  <div className="text-center text-primary-color">
                    STCW-F; Torremolinos and Work In Fishing Convention (C188)
                  </div>

                  <div className="card-share">
                    {/* <button type="button" className="btn-share border-0">
                      <i className="bi bi-share"></i>
                    </button> */}
                    <ul>
                      <li>
                        <a href="#">
                          <FaFacebookF />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <FaTwitter />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <FaLinkedinIn />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <FaInstagram />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <FaYoutube />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-md-6 col-sm-6">
              <div className="gray-card-wrap">
                <div className="gray-card bg-gray-de bg-opacity-10 d-flex flex-column align-items-center">
                  <div className="icon">
                    <img src={scaleIcon} alt="" />
                  </div>
                  <div className="text-center text-primary-color font-600">
                    {" "}
                    Safety Regulations
                  </div>
                  <div className="text-center text-primary-color">
                    STCW-F; Torremolinos and Work In Fishing Convention (C188)
                  </div>

                  <div className="card-share">
                    {/* <button type="button" className="btn-share border-0">
                      <i className="bi bi-share"></i>
                    </button> */}
                    <ul>
                      <li>
                        <a href="#">
                          <FaFacebookF />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <FaTwitter />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <FaLinkedinIn />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <FaInstagram />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <FaYoutube />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-5">
          <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
        </div>
        <div className="col-12">
          <div className="row g-4">
            {cardData.map((card, index) => (
              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6" key={index}>
                <div className="gray-card-wrap">
                  <div className="gray-card bg-gray-de bg-opacity-10 d-flex flex-column align-items-center">
                    <div className="icon">
                      <img src={card.icon} alt="" />
                    </div>
                    <div className="text-center text-primary-color font-600">
                      {card.cardTitle}
                    </div>
                    <div className="text-center text-primary-color">
                      {card.cardDescription}
                    </div>

                    <div className="card-share">
                      {/* <button type="button" className="btn-share border-0">
                        <i className="bi bi-share"></i>
                      </button> */}
                      <ul>
                        <li>
                          <a href="#">
                            <FaFacebookF />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaTwitter />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaLinkedinIn />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaInstagram />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaYoutube />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* <div className="col-12">
          <div className="accordion blackTab" id="blackTab">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabOne"
                  aria-expanded="true"
                  aria-controls="blackTabOne"
                >
                  KEY PROJECTS
                </button>
              </h2>
              <div
                id="blackTabOne"
                className="accordion-collapse collapse show"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <ul class="green-star-ul">
                    <li>National Fishing Forum</li>
                    <li>Communication and awareness​</li>
                    <li>New and pending Fishing related Legislations</li>
                    <li>Seminars and Workshops to Fishing companies</li>
                    <li>CSI: Sustainable Fishing Community Pilot Project,</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
}

export default FishingOverviewTab;